import React, { forwardRef } from 'react';
import { styled as styled2 } from '@compiled/react';
// eslint-disable-next-line jira/restricted/styled-components-migration, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from 'styled-components';
import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import { token } from '@atlaskit/tokens';
import Tooltip, { type TooltipProps } from '@atlaskit/tooltip';
import {
	buildWfeUrlWithTransitionId,
	buildWorkflowSchemeJSPUrl,
} from '@atlassian/jira-admin-screens-services/src/services/screens-service/actions/utils';
import Link from '@atlassian/jira-common-analytics-v2-wrapped-components/src/link';
import { gridSize } from '@atlassian/jira-common-styles/src/main.tsx';
import { fireUIAnalytics, ContextualAnalyticsData } from '@atlassian/jira-product-analytics-bridge';
import { useNewWorkflowEditorPreference } from '@atlassian/jira-workflow-editor-preference-settings/src/controllers/editor-preference/index.tsx';
import type { Props } from './types';

const MAX_TRANSITION_NAME_LENGTH = 25;

const SpanTag = forwardRef((props: TooltipProps, ref) => {
	const { children, ...rest } = props;
	return (
		// @ts-expect-error - TS2322 - Type '((instance: unknown) => void) | MutableRefObject<unknown> | null' is not assignable to type 'LegacyRef<HTMLSpanElement> | undefined'.
		<span {...rest} ref={ref}>
			{/* @ts-expect-error - TS2322 - Type 'ReactNode | ((props: TriggerProps) => ReactNode)' is not assignable to type 'ReactNode'. */}
			{children}
		</span>
	);
});

const ListWorkflows = ({ workflowTransitions, testId, tooltipDelay }: Props) => {
	const { shouldUseNewWorkFlowEditor } = useNewWorkflowEditorPreference();
	return (
		<ListWrapper>
			<ul>
				{workflowTransitions.map((workflow) => (
					<li key={workflow.workflowTransitionId}>
						<ListItem>
							<ContextualAnalyticsData containers={{ screen: { id: `${workflow.screenId}` } }}>
								<Link
									href={
										// @TODO HIX-2810 remove checking workflowId on FF hix-2936-add-workflow-id-to-screens-api-response clean up
										// HIX-2810 TO-DO moved to src/packages/project-settings/workflow-editor-preference-settings/src/controllers/user-preference/index.tsx
										shouldUseNewWorkFlowEditor && workflow.workflowId
											? buildWfeUrlWithTransitionId(workflow)
											: buildWorkflowSchemeJSPUrl(workflow)
									}
									// @ts-expect-error - TS7006 - Parameter '_' implicitly has an 'any' type.
									onClick={(_, analyticsEvent: UIAnalyticsEvent) => {
										fireUIAnalytics(analyticsEvent, 'workflowTransition');
									}}
								>
									{workflow.workflowName}
								</Link>
								<Tooltip
									content={workflow.workflowTransitionName}
									// @ts-expect-error - TS2322 - Type 'ForwardRefExoticComponent<TooltipProps & RefAttributes<unknown>>' is not assignable to type 'keyof IntrinsicElements | ComponentType<AllHTMLAttributes<HTMLElement> & { ref: Ref<HTMLElement>; }> | undefined'.
									tag={SpanTag}
									delay={tooltipDelay}
								>
									<span data-testid={testId}>
										{' '}
										(
										{(workflow.workflowTransitionName || '').length > MAX_TRANSITION_NAME_LENGTH
											? `${workflow.workflowTransitionName.substr(
													0,
													MAX_TRANSITION_NAME_LENGTH,
												)}...`
											: workflow.workflowTransitionName}
										)
									</span>
								</Tooltip>
							</ContextualAnalyticsData>
						</ListItem>
					</li>
				))}
			</ul>
		</ListWrapper>
	);
};

export default ListWorkflows;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ListWrapper = styled.div({
	display: 'flex',
	flexDirection: 'column',
	boxSizing: 'border-box',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	minHeight: `${6 * gridSize}px`,
	paddingBottom: token('space.100', '8px'),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
	ul: {
		paddingLeft: token('space.200', '16px'),
	},
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ListItem = styled2.div({
	display: 'inline',
});
